export default __webpack_public_path__ + "14d2fc7a23ea1dcfb9a8e768fc469ea8.svg";